export const optionsForReceiptType: Array<string> = ['invoice', 'cancel'];
